import dayjs from "dayjs";
import { toTitleCase } from "../utils/generalUtils";

// Calculations (for frontend live preview only)
export const calculations = {
  teachingLoadUpou: (values) => {
    const { number_of_students, course_credits, course_type } = values;

    let student_credit_units = null;
    let teaching_load_credits = null;

    if (number_of_students != null && course_credits != null) {
      student_credit_units = number_of_students * course_credits;
    }

    if (number_of_students != null) {
      if (course_type === "Thesis") {
        teaching_load_credits = 0;
      } else if (course_type === "Capstone") {
        teaching_load_credits =
          number_of_students >= 7 ? 4 : number_of_students * 0.5;
      } else if (course_type === "Regular") {
        teaching_load_credits = number_of_students >= 60 ? 4.5 : 3;
      }
    }

    return { student_credit_units, teaching_load_credits };
  },

  teachingLoadOtherUp: (values) => {
    const { number_of_students, course_credits } = values;

    let student_credit_units = null;
    // let teaching_load_credits = null;

    if (number_of_students != null && course_credits != null) {
      student_credit_units = number_of_students * course_credits;
    }

    // if (number_of_students != null) {
    //   teaching_load_credits = number_of_students >= 60 ? 4.5 : 3;
    // }

    return { student_credit_units };
  },

  tutorialWork: (values) => {
    const n = values.number_of_students;

    if (n == null) return { approved_credit_units: null };

    let acu = 0;

    if (n <= 10) acu = 0;
    else if (n <= 19) acu = 0.75;
    else if (n <= 30) acu = 1.5;
    else if (n <= 39) acu = 2.25;
    else if (n <= 50) acu = 3;
    else if (n <= 59) acu = 3.75;
    else if (n <= 70) acu = 4.5;
    else if (n <= 79) acu = 5.25;
    else if (n <= 90) acu = 6;
    else if (n <= 99) acu = 6.75;
    else if (n <= 110) acu = 7.5;
    else if (n <= 119) acu = 8.25;
    else if (n <= 130) acu = 9;
    else if (n <= 139) acu = 9.75;
    else if (n <= 150) acu = 10.5;
    else if (n <= 159) acu = 11.25;
    else if (n <= 170) acu = 12;
    else if (n <= 179) acu = 12.75;
    else if (n <= 190) acu = 13.5;
    else if (n <= 199) acu = 14.25;
    else if (n <= 210) acu = 15;
    else if (n <= 219) acu = 15.75;
    else if (n <= 230) acu = 16.5;
    else if (n <= 239) acu = 17.25;
    else if (n <= 250) acu = 18;
    else if (n <= 259) acu = 18.75;
    else if (n <= 270) acu = 19.5;
    else if (n <= 279) acu = 20.25;
    else if (n <= 290) acu = 21;
    else if (n <= 299) acu = 21.75;
    else if (n <= 310) acu = 22.5;
    else if (n <= 319) acu = 23.25;
    else if (n <= 330) acu = 24;
    else if (n <= 339) acu = 24.75;
    else if (n <= 350) acu = 25.5;
    else if (n <= 359) acu = 26.25;
    else if (n <= 370) acu = 27;
    else if (n <= 379) acu = 27.75;
    else if (n <= 390) acu = 28.5;
    else if (n <= 399) acu = 29.25;
    else if (n <= 410) acu = 30;
    else if (n <= 419) acu = 30.75;
    else if (n <= 430) acu = 31.5;
    else if (n <= 439) acu = 32.25;
    else if (n <= 450) acu = 33;
    else if (n <= 459) acu = 33.75;
    else if (n <= 470) acu = 34.5;
    else if (n <= 479) acu = 35.25;
    else if (n <= 490) acu = 36;
    else if (n <= 499) acu = 36.75;
    else if (n <= 510) acu = 37.5;
    else if (n <= 519) acu = 38.25;

    return { approved_credit_units: acu };
  },
};

// Table and modal configurations
export const facultyProfileConfig = {
  teachingLoad: {
    title: "Teaching Load",

    tabs: {
      upou: {
        label: "In UPOU",

        calculate: calculations.teachingLoadUpou,

        columns: [
          {
            title: "Academic Term",
            dataIndex: "academic_term",
            key: "academic_term",
          },
          {
            title: "Course No.",
            dataIndex: "course_number",
            key: "course_number",
          },
          {
            title: "Course Title",
            dataIndex: "course_title",
            key: "course_title",
          },
          {
            title: "Course Type",
            dataIndex: "course_type",
            key: "course_type",
          },
          {
            title: "No. of Students",
            dataIndex: "number_of_students",
            key: "number_of_students",
          },
          {
            title: "Course Credits",
            dataIndex: "course_credits",
            key: "course_credits",
          },
          {
            title: "Student Credit Units",
            dataIndex: "student_credit_units",
            key: "student_credit_units",
          },
          {
            title: "Teaching Load Credits",
            dataIndex: "teaching_load_credits",
            key: "teaching_load_credits",
          },
          {
            title: "Proof",
            dataIndex: "proof",
            key: "proof",
            width: 300,
            render: (value) =>
              value ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {value}
                </a>
              ) : (
                "-"
              ),
          },
        ],

        fields: [
          {
            name: "academic_term",
            label: "Academic Term",
            type: "term-select",
            required: true,
          },
          {
            name: "course_number",
            label: "Course No.",
            type: "course-dropdown",
            required: true,
          },
          {
            name: "course_title",
            label: "Course Title",
            type: "read-only-text",
            required: true,
          },
          {
            name: "course_type",
            label: "Course Type",
            type: "course-type-radio",
            required: true,
          },
          {
            name: "number_of_students",
            label: "No. of Students (A)",
            type: "integer",
            required: true,
          },
          {
            name: "course_credits",
            label: "Course Credits w/o multipliers (B)",
            type: "float",
            required: true,
          },
          {
            name: "student_credit_units",
            label: "Student Credit Units (A x B)",
            type: "read-only-text",
            required: true,
          },
          {
            name: "teaching_load_credits",
            label: "Teaching Load Credits w/ multipliers",
            type: "read-only-text",
            required: true,
          },
          {
            name: "proof",
            label: "Proof (URL)",
            type: "text",
          },
        ],
      },

      otherUp: {
        label: "In Other UP Units",

        calculate: calculations.teachingLoadOtherUp,

        columns: [
          {
            title: "Academic Term",
            dataIndex: "academic_term",
            key: "academic_term",
          },
          {
            title: "UP Unit",
            dataIndex: "up_unit",
            key: "up_unit",
          },
          {
            title: "Course No.",
            dataIndex: "course_number",
            key: "course_number",
          },
          {
            title: "Section Code",
            dataIndex: "section_code",
            key: "section_code",
          },
          {
            title: "Room",
            dataIndex: "room",
            key: "room",
          },
          {
            title: "Days",
            dataIndex: "days",
            key: "days",
          },
          {
            title: "Time",
            dataIndex: "time",
            key: "time",
          },
          {
            title: "Hrs. per week",
            dataIndex: "hours_per_week",
            key: "hours_per_week",
          },
          {
            title: "No. of Students",
            dataIndex: "number_of_students",
            key: "number_of_students",
          },
          {
            title: "Course Credits",
            dataIndex: "course_credits",
            key: "course_credits",
          },
          {
            title: "Student Credit Units",
            dataIndex: "student_credit_units",
            key: "student_credit_units",
          },
          {
            title: "Teaching Load Credits",
            dataIndex: "teaching_load_credits",
            key: "teaching_load_credits",
          },
          {
            title: "Proof",
            dataIndex: "proof",
            key: "proof",
            width: 300,
            render: (value) =>
              value ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {value}
                </a>
              ) : (
                "-"
              ),
          },
        ],

        fields: [
          {
            name: "academic_term",
            label: "Academic Term",
            type: "term-select",
            required: true,
          },
          {
            name: "up_unit",
            label: "UP Unit",
            type: "text",
            required: true,
          },
          {
            name: "course_number",
            label: "Course No.",
            type: "text",
            required: true,
          },
          {
            name: "section_code",
            label: "Section Code",
            type: "text",
            required: true,
          },
          {
            name: "room",
            label: "Room",
            type: "text",
            required: true,
          },
          {
            name: "days",
            label: "Days",
            type: "text",
            required: true,
          },
          {
            name: "time",
            label: "Time",
            type: "text",
            required: true,
          },
          {
            name: "hours_per_week",
            label: "Hrs. per week",
            type: "float",
            required: true,
          },
          {
            name: "number_of_students",
            label: "No. of Students (A)",
            type: "integer",
            required: true,
          },
          {
            name: "course_credits",
            label: "Course Credits w/o multipliers (B)",
            type: "float",
            required: true,
          },
          {
            name: "student_credit_units",
            label: "Student Credit Units (A x B)",
            type: "read-only-text",
            required: true,
          },
          {
            name: "teaching_load_credits",
            label: "Teaching Load Credits w/ multipliers",
            type: "float",
            required: true,
          },
          {
            name: "proof",
            label: "Proof (URL)",
            type: "text",
          },
        ],
      },

      outsideUp: {
        label: "Outside UP",

        columns: [
          {
            title: "Academic Term",
            dataIndex: "academic_term",
            key: "academic_term",
          },
          {
            title: "College",
            dataIndex: "college",
            key: "college",
          },
          {
            title: "No. of Subjects",
            dataIndex: "number_of_subjects",
            key: "number_of_subjects",
          },
          {
            title: "No. of Units",
            dataIndex: "number_of_units",
            key: "number_of_units",
          },
          {
            title: "Proof",
            dataIndex: "proof",
            key: "proof",
            width: 300,
            render: (value) =>
              value ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {value}
                </a>
              ) : (
                "-"
              ),
          },
        ],

        fields: [
          {
            name: "academic_term",
            label: "Academic Term",
            type: "term-select",
            required: true,
          },
          {
            name: "college",
            label: "College",
            type: "text",
            required: true,
          },
          {
            name: "number_of_subjects",
            label: "No. of Subjects",
            type: "integer",
            required: true,
          },
          {
            name: "number_of_units",
            label: "No. of Units",
            type: "float",
            required: true,
          },
          {
            name: "proof",
            label: "Proof (URL)",
            type: "text",
          },
        ],
      },
    },
  },

  research: {
    title: "Research, Textbook Writing, Course Development, & Creative Work",

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "Nature of Involvement",
        dataIndex: "nature_of_involvement",
        key: "nature_of_involvement",
      },
      {
        title: "Start Date",
        dataIndex: "start_date",
        key: "start_date",
      },
      {
        title: "End Date",
        dataIndex: "end_date",
        key: "end_date",
      },
      {
        title: "Funded?",
        dataIndex: "is_funded",
        key: "is_funded",
        render: (value) => (value === 1 || value === true ? "Yes" : "No"),
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "title",
        label: "Title",
        type: "text",
        required: true,
      },
      {
        name: "nature_of_involvement",
        label: "Nature of Involvement",
        type: "text",
        required: true,
      },
      {
        name: "start_date",
        label: "Start Date",
        type: "date",
        required: true,
      },
      {
        name: "end_date",
        label: "End Date",
        type: "date",
        required: true,
      },
      {
        name: "is_funded",
        label: "Funded?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "float",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  administrativeWork: {
    title: "Administrative Work",

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Position/Nature",
        dataIndex: "position",
        key: "position",
      },
      {
        title: "Office/Unit",
        dataIndex: "office",
        key: "office",
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "position",
        label: "Position / Nature of Administration Work",
        type: "text",
        required: true,
      },
      {
        name: "office",
        label: "Office/Unit",
        type: "text",
        required: true,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "float",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  tutorialWork: {
    title: "Tutorial Work",

    calculate: calculations.tutorialWork,

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Course",
        dataIndex: "course",
        key: "course",
      },
      {
        title: "Learning Center",
        dataIndex: "learning_center",
        key: "learning_center",
      },
      {
        title: "No. of Students",
        dataIndex: "number_of_students",
        key: "number_of_students",
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "course",
        label: "Course",
        type: "text",
        required: true,
      },
      {
        name: "learning_center",
        label: "Learning Center",
        type: "text",
        required: true,
      },
      {
        name: "number_of_students",
        label: "No. of Students",
        type: "integer",
        required: true,
        max: 519,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "read-only-text",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  extensionService: {
    title: "Extension and Community Service",

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Position/Nature",
        dataIndex: "position",
        key: "position",
      },
      {
        title: "Office/Unit",
        dataIndex: "office",
        key: "office",
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "position",
        label: "Position / Nature of Extension Work",
        type: "text",
        required: true,
      },
      {
        name: "office",
        label: "Office/Unit",
        type: "text",
        required: true,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "float",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  consultationHours: {
    title: "Consultation Hours",

    columns: [
      {
        title: "Day",
        dataIndex: "day",
        key: "day",
      },
      {
        title: "Start Time",
        dataIndex: "start_time",
        key: "start_time",
        render: (value) =>
          value ? dayjs(value, "HH:mm:ss").format("hh:mm A") : "",
      },
      {
        title: "End Time",
        dataIndex: "end_time",
        key: "end_time",
        render: (value) =>
          value ? dayjs(value, "HH:mm:ss").format("hh:mm A") : "",
      },
      {
        title: "Place",
        dataIndex: "place",
        key: "place",
      },
    ],

    fields: [
      {
        name: "day",
        label: "Day",
        type: "day-select",
        required: true,
      },
      {
        name: "start_time",
        label: "Start Time",
        type: "time",
        required: true,
      },
      {
        name: "end_time",
        label: "End Time",
        type: "time",
        required: true,
      },
      {
        name: "place",
        label: "Place",
        type: "text",
        required: true,
      },
    ],
  },

  studyLoad: {
    title: "Study Load",

    fields: [
      {
        name: "is_enrolled",
        label: "Currently enrolled in a degree?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "degree",
        label: "Degree Enrolled In",
        type: "text",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "university",
        label: "University Enrolled In",
        type: "text",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "total_units",
        label: "Total Units Enrolled In",
        type: "float",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "is_on_leave_with_pay",
        label: "On full study leave with pay?",
        type: "yes-no-radio",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "is_recipient",
        label: "Recipient of faculty fellowship?",
        type: "yes-no-radio",
        required: true,
      },
    ],
  },

  limitedPractice: {
    title: "Limited Practice of Profession",

    fields: [
      {
        name: "is_applied",
        label:
          "Applied for official permission for limited practice of profession?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "submission_date",
        label: "Date permission was submitted",
        type: "date",
        required: true,
        showIf: {
          field: "is_applied",
          value: true,
        },
      },
      {
        name: "approval_date",
        label: "Date permission was approved",
        type: "date",
        required: true,
        showIf: {
          field: "is_applied",
          value: true,
        },
      },
    ],
  },

  recipientOrNominee: {
    title: "Professorial Chair or Faculty Grant Recipient or Nominee",

    fields: [
      {
        name: "is_recipient_or_nominee",
        label: "Are you a recipient/nominee?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "is_nominated_but_no_appt",
        label:
          "No appointment has been approved as of today but faculty has already nominated?",
        type: "yes-no-radio",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "nomination",
        label: "What are you nominated for?",
        type: "nomination-radio",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "title",
        label: "Chair/Grant Title",
        type: "text",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "start_date",
        label: "Approved Start Date",
        type: "date",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "end_date",
        label: "Approved End Date",
        type: "date",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
    ],
  },
};
